import styled from 'styled-components';

import { shade } from 'polished';

import colors from 'styles/colors';

export interface IContainerProps {
  backgroundColor?: string;
  borderColor?: string;
  borderRadius?: string;
  color?: string;
  height?: string;
  width?: string;
}
export const Container = styled.button<IContainerProps>`
  align-items: center;
  background-color: ${props =>
    props.backgroundColor ? props.backgroundColor : colors.cyan900};
  border: 1px solid
    ${props => (props.borderColor ? props.borderColor : colors.transparent)};
  border-radius: ${props =>
    props.borderRadius ? props.borderRadius : '.5rem'};
  color: ${props => (props.color ? props.color : colors.white900)};
  column-gap: 0.5rem;
  display: flex;
  font-size: 0.875rem;
  font-weight: 500;
  height: ${props => (props.height ? props.height : '2.25rem')};
  justify-content: center;
  margin-top: 1rem;
  width: ${props => (props.width ? props.width : '100%')};

  @media (min-width: 850px) {
    &:hover {
      background-color: ${props =>
        shade(
          0.15,
          props.backgroundColor ? props.backgroundColor : colors.cyan900,
        )};
      border-color: ${props =>
        shade(0.2, props.borderColor ? props.borderColor : colors.transparent)};
      color: ${props =>
        shade(0.1, props.color ? props.color : colors.white900)};
    }
  }
`;
